import { useState } from "react";
import { useModalStore } from "../../../stores/modalStore.js";
import { useServerStore } from "../../../stores/serverStore.js";

export function EditServerModal() {
  const { isOpen, type, data, onClose } = useModalStore();
  const updateServer = useServerStore((state) => state.updateServer);
  
  const [serverName, setServerName] = useState(data?.server?.name || "");
  const [serverDescription, setServerDescription] = useState(data?.server?.description || "");

  const isModalOpen = isOpen && type === "editServer";

  if (!isModalOpen) return null;

  const handleSave = () => {
    if (!serverName.trim()) return;

    updateServer(data.server.id, {
      name: serverName,
      description: serverDescription,
    });

    onClose();
  };

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#1a1a1a",
          border: "1px solid #2a2a2a",
          borderRadius: "8px",
          padding: "24px",
          width: "90%",
          maxWidth: "500px",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
          <h2 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#fff" }}>Edit Server</h2>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              color: "#666",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>

        <div style={{ marginBottom: "16px" }}>
          <label style={{ display: "block", fontSize: "0.875rem", color: "#999", marginBottom: "8px" }}>
            Server Name
          </label>
          <input
            type="text"
            value={serverName}
            onChange={(e) => setServerName(e.target.value)}
            placeholder="Enter server name"
            style={{
              width: "100%",
              background: "#0f0f0f",
              border: "1px solid #2a2a2a",
              borderRadius: "4px",
              padding: "12px",
              color: "#e0e0e0",
              fontFamily: "'Roboto Mono', monospace",
            }}
          />
        </div>

        <div style={{ marginBottom: "24px" }}>
          <label style={{ display: "block", fontSize: "0.875rem", color: "#999", marginBottom: "8px" }}>
            Description (optional)
          </label>
          <textarea
            value={serverDescription}
            onChange={(e) => setServerDescription(e.target.value)}
            placeholder="What's this server about?"
            rows={3}
            style={{
              width: "100%",
              background: "#0f0f0f",
              border: "1px solid #2a2a2a",
              borderRadius: "4px",
              padding: "12px",
              color: "#e0e0e0",
              fontFamily: "'Roboto Mono', monospace",
              resize: "vertical",
            }}
          />
        </div>

        <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
          <button
            onClick={onClose}
            style={{
              padding: "10px 20px",
              background: "#2a2a2a",
              border: "none",
              borderRadius: "4px",
              color: "#e0e0e0",
              cursor: "pointer",
              fontFamily: "'Roboto Mono', monospace",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={!serverName.trim()}
            style={{
              padding: "10px 20px",
              background: serverName.trim() ? "#0066ff" : "#2a2a2a",
              border: "none",
              borderRadius: "4px",
              color: "#fff",
              cursor: serverName.trim() ? "pointer" : "not-allowed",
              fontFamily: "'Roboto Mono', monospace",
            }}
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}
